/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize'
import { labelPositionMapStyle } from '@/constants/positions'
import { useNotification } from '@/containers'
import { type ProductDetail } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Image from 'next/image'
import type { FC } from 'react'
import { useRef } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import ProductPrice from '../EntrySummary/ProductPrice'

interface Props {
  images: string[]
  alt: string
  flashSale: ProductDetail
  product: ProductDetail
  label: ProductDetail
  isOutOfStock: boolean
  video?: string
}
export const CustomPrevArrow = (props: any) => {
  const { className, onClick } = props
  return (
    <div className={`${className} custom-nav !left-2 z-10`} onClick={onClick}>
      <Image
        src='/assets/icons/arrowSwiper.svg'
        width={36}
        height={36}
        alt='Prev'
      />
    </div>
  )
}

export const CustomNextArrow = (props: any) => {
  const { className, onClick } = props
  return (
    <div className={`${className} custom-nav !right-2 z-10`} onClick={onClick}>
      <Image
        src='/assets/icons/arrowSwiper.svg'
        className='rotate-180'
        width={36}
        height={36}
        alt='Prev'
      />
    </div>
  )
}

export const Gallery: FC<Props> = ({
  images,
  alt,
  flashSale,
  product,
  label,
  isOutOfStock,
}: Props) => {
  const sliderMain = useRef<Slider | null>(null)

  const settingsMain: Settings = {
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    className: 'overflow-hidden productGalleryMain',
  }
  const { systemConfig } = useNotification()
  return (
    <div className={`image-summary bg-white`}>
      {images?.length === 0 ? (
        <ImageOptimize
          quality={100}
          className='cartImage w-full object-cover'
          src={
            systemConfig?.imageWarehousePlaceholder ||
            process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
            ''
          }
          loading='lazy'
          alt={alt}
          width={400}
          height={400}
        />
      ) : (
        <div className='image-summary-image relative'>
          <Slider {...settingsMain} ref={sliderMain}>
            {images?.map((e, i) => {
              return (
                <div className='relative flex justify-center ' key={i}>
                  <ImageOptimize
                    key={i}
                    className='relative aspect-square h-full w-full object-contain'
                    height={600}
                    width={600}
                    alt={alt}
                    src={
                      i === 0 && product.videoUrl && product.videoThumbnail
                        ? product.videoThumbnail
                        : e
                    }
                    quality={100}
                  />
                </div>
              )
            })}
          </Slider>
          {label &&
            label?.labels
              ?.filter(e => e?._id)
              .map((item, index) => {
                return (
                  <span
                    className={`${labelPositionMapStyle.get(
                      item?.position
                    )} label absolute hiddenScrollBar w-max`}
                    style={{ zIndex: 20 - index }}
                    key={index}
                  >
                    <ImageOptimize
                      src={item?.image}
                      alt={getTranslate(item?.name)}
                      width={217}
                      height={40}
                      className='w-full align-middle h-auto'
                    />
                  </span>
                )
              })}
        </div>
      )}
      {flashSale?.flashSale && (
        <ProductPrice
          isOutOfStock={isOutOfStock}
          priceAtWarehouse={flashSale?.priceAtWarehouse}
          originPrice={flashSale?.price}
          finalPrice={flashSale?.finalPrice}
          preOrderPrice={flashSale?.preOrder?.salePrice}
          flashSale={flashSale?.flashSale}
          productId={flashSale?._id}
          hasGift={flashSale?.gifts && flashSale?.gifts?.length > 0}
          preOrder={flashSale?.preOrder}
          hasDeal={flashSale?.exclusiveDeal}
          priceDescription={flashSale?.priceDescription}
        />
      )}
    </div>
  )
}
